import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { WAITLIST_ONLY } from '../config';

function Header({ activeNavItem, setActiveNavItem, isAuthenticated, logout, onLoginClick }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Product auth is off site-wide while waitlist-only
  const authed = WAITLIST_ONLY ? false : !!isAuthenticated;

  const handleNavClick = (item) => {
    setActiveNavItem(item);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header className="app-header">
        <div className="header-content">
          <div className="logo-section">
            <img
              src="/textlogo.png"
              alt="Logo"
              className="main-logo"
              onClick={() => handleNavClick('overview')}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          <nav className="nav-section desktop-nav">
            <button
              className={`nav-button ${activeNavItem === 'overview' ? 'active' : ''}`}
              onClick={() => handleNavClick('overview')}
            >
              Home
            </button>
            <button
              className={`nav-button ${activeNavItem === 'how-it-works' ? 'active' : ''}`}
              onClick={() => handleNavClick('how-it-works')}
            >
              How it Works
            </button>
            {authed && (
              <>
                <button
                  className={`nav-button ${activeNavItem === 'create' ? 'active' : ''}`}
                  onClick={() => handleNavClick('create')}
                >
                  Create
                </button>
                <button
                  className={`nav-button ${activeNavItem === 'workflows' ? 'active' : ''}`}
                  onClick={() => handleNavClick('workflows')}
                >
                  Workflows
                </button>
                <button
                  className={`nav-button ${activeNavItem === 'local-optimize' ? 'active' : ''}`}
                  onClick={() => handleNavClick('local-optimize')}
                >
                  Optimize Locally
                </button>
              </>
            )}
            <button
              className={`nav-button ${activeNavItem === 'pricing' ? 'active' : ''}`}
              onClick={() => handleNavClick('pricing')}
            >
              Pricing
            </button>
          </nav>

          <div className="auth-section desktop-auth">
            {authed ? (
              <>
                <button
                  className="dashboard-button"
                  onClick={() => handleNavClick('dashboard')}
                >
                  Dashboard
                </button>
                <button className="auth-button" onClick={() => logout('all')}>
                  Sign Out
                </button>
              </>
            ) : (
              <button className="auth-button waitlist-cta" onClick={onLoginClick}>
                {WAITLIST_ONLY ? 'Join Waitlist' : 'Login'}
              </button>
            )}
          </div>
        </div>
      </header>

      <div className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          <button
            className={`mobile-nav-item ${activeNavItem === 'overview' ? 'active' : ''}`}
            onClick={() => handleNavClick('overview')}
          >
            Home
          </button>
          <button
            className={`mobile-nav-item ${activeNavItem === 'how-it-works' ? 'active' : ''}`}
            onClick={() => handleNavClick('how-it-works')}
          >
            How it Works
          </button>
          {authed && (
            <>
              <button
                className={`mobile-nav-item ${activeNavItem === 'create' ? 'active' : ''}`}
                onClick={() => handleNavClick('create')}
              >
                Create
              </button>
              <button
                className={`mobile-nav-item ${activeNavItem === 'workflows' ? 'active' : ''}`}
                onClick={() => handleNavClick('workflows')}
              >
                Workflows
              </button>
              <button
                className={`mobile-nav-item ${activeNavItem === 'local-optimize' ? 'active' : ''}`}
                onClick={() => handleNavClick('local-optimize')}
              >
                Optimize Locally
              </button>
            </>
          )}
          <button
            className={`mobile-nav-item ${activeNavItem === 'pricing' ? 'active' : ''}`}
            onClick={() => handleNavClick('pricing')}
          >
            Pricing
          </button>

          <div className="mobile-auth-section">
            {authed ? (
              <>
                <button
                  className="mobile-nav-item dashboard"
                  onClick={() => handleNavClick('dashboard')}
                >
                  Dashboard
                </button>
                <button
                  className="mobile-nav-item signout"
                  onClick={() => {
                    logout('all');
                    setMobileMenuOpen(false);
                  }}
                >
                  Sign Out
                </button>
              </>
            ) : (
              <button
                className="mobile-login-btn"
                onClick={() => {
                  onLoginClick();
                  setMobileMenuOpen(false);
                }}
              >
                {WAITLIST_ONLY ? 'Join Waitlist' : 'Login'}
              </button>
            )}
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;
